"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_1 = require("@seaweb/coral/hoc/styled");
var normalizeSize_1 = __importDefault(require("@seaweb/coral/utils/normalizeSize"));
var fallback_1 = __importDefault(require("@seaweb/coral/utils/fallback"));
exports.baseStyle = styled_1.css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  margin: 0;\n  line-height: 1.43;\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"], ["\n  margin: 0;\n  line-height: 1.43;\n\n  ",
    "\n\n  ",
    "\n\n  ",
    "\n\n  ",
    "\n\n  ",
    "\n"])), function (_a) {
    var _b = _a.opacity, opacity = _b === void 0 ? 1 : _b;
    return styled_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    opacity: ", ";\n  "], ["\n    opacity: ", ";\n  "])), opacity);
}, function (_a) {
    var colors = _a.theme.colors, color = _a.color, colorType = _a.colorType;
    return styled_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), fallback_1.default(fallback_1.default(color, colors[colorType]), colors.alternate));
}, function (_a) {
    var fontSize = _a.fontSize;
    return fontSize !== undefined && styled_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      font-size: ", ";\n    "], ["\n      font-size: ", ";\n    "])), normalizeSize_1.default(fontSize));
}, function (_a) {
    var fontWeight = _a.fontWeight;
    return fontWeight !== undefined && styled_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      font-weight: ", ";\n    "], ["\n      font-weight: ", ";\n    "])), fontWeight);
}, function (_a) {
    var margin = _a.margin;
    return margin !== undefined && styled_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      margin: ", ";\n    "], ["\n      margin: ", ";\n    "])), normalizeSize_1.default(margin));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
